import classNames from 'classnames';
import { React, bind } from 'Imports';
import { VideoEventResponse } from '$Generated/api';
import { VideoEventRecallCard_SplitOff } from '$Components/VideoRecall/VideoEventRecallCard_SplitOff';
import { ConfigService, IConfigServiceInjectedProps } from '$State/ConfigFreezerService';
import * as VideoAssets from '$Components/Shared/VideoAssetsUrls';
import VideoRecallCard from '$Components/VideoRecall/VideoRecallCard/VideoRecallCard';
import { isEncompass } from '$Utilities/integrationPlatform';

const InfiniteScroll: any = require('react-infinite-scroller');
interface IVideoEventCardListProps {
    items: VideoEventResponse[];
    onSelectVideoEvent: (eventId: string, goBack: boolean) => void;
    loadNextPage: () => void;
    morePagesToLoad: boolean;
    updateVideoEventWorkflowStatus: (eventId: number | undefined) => void;
    deleteVideoRecall?: (eventId: number) => void;
    promoteVideo: (eventId: number) => void;
    videoRecallPreviewEnabled?: boolean;
    isVideoRecallRedesignV2SplitOn?: boolean;
    onPromotedVideo: () => void;
    onDeletedVideo: () => void;
}

const styles = require('$Components/VideoRecall/VideoEventCardList.scss') as {
    mainSplitOff: string;
    mainGeotab: string;
    mainEncompass: string;
    card: string;
    scrollWindow: string;
    videoRecallPreviewEnabled: string;
};

class _VideoEventCardList extends React.Component<IVideoEventCardListProps & IConfigServiceInjectedProps, {}> {
    private scrollParentRefRecall1: any;
    @bind
    loadVideoEventsOnScroll(): void {
        this.props.loadNextPage();
    }

    @bind
    deleteVideoRecall(eventId: number): void {
        if (this.props.deleteVideoRecall) {
            this.props.deleteVideoRecall(eventId);
        }
    }

    render(): JSX.Element {
        return (
            <div className={styles.scrollWindow} ref={(ref) => (this.scrollParentRefRecall1 = ref)}>
                <InfiniteScroll
                    pageStart={1}
                    loadMore={this.loadVideoEventsOnScroll}
                    hasMore={this.props.morePagesToLoad}
                    loader={<div className="loader">Loading ...</div>}
                    useWindow={false}
                    getScrollParent={() => this.scrollParentRefRecall1}
                >
                    <div
                        className={classNames(
                            this.props.isVideoRecallRedesignV2SplitOn
                                ? isEncompass
                                    ? styles.mainEncompass
                                    : styles.mainGeotab
                                : styles.mainSplitOff,
                            this.props.videoRecallPreviewEnabled && styles.videoRecallPreviewEnabled,
                        )}
                    >
                        {this.props.items.map((videoEvent: VideoEventResponse, idx: number) => {
                            const assets = videoEvent.videoAsset || [];

                            const videoUrls = VideoAssets.findPreviewUrls(assets, this.props.config.getBaseUrl());
                            return this.props.isVideoRecallRedesignV2SplitOn ? (
                                <VideoRecallCard
                                    key={videoEvent.id ?? idx}
                                    videoEvent={videoEvent}
                                    onSelectVideoEvent={this.props.onSelectVideoEvent}
                                    updateVideoEventWorkflowStatus={this.props.updateVideoEventWorkflowStatus}
                                    onPromotedVideo={this.props.onPromotedVideo}
                                    onDeletedVideo={this.props.onDeletedVideo}
                                ></VideoRecallCard>
                            ) : (
                                <div key={videoEvent.id ?? idx} className={styles.card}>
                                    <VideoEventRecallCard_SplitOff
                                        key={videoEvent.id ?? idx}
                                        onSelectVideoEvent={this.props.onSelectVideoEvent}
                                        updateVideoEventWorkflowStatus={this.props.updateVideoEventWorkflowStatus}
                                        deleteVideoRecall={this.deleteVideoRecall}
                                        promoteVideo={this.props.promoteVideo}
                                        videoEvent={videoEvent}
                                        videoEventUrls={videoUrls}
                                    ></VideoEventRecallCard_SplitOff>
                                </div>
                            );
                        })}
                    </div>
                </InfiniteScroll>
            </div>
        );
    }
}

export const VideoEventCardList = ConfigService.inject(_VideoEventCardList);
